import BossModel from "@/models/BossModel";
import Day from "@/models/Margin/MarginGroup/Day/Day";

export default class MarginGroup extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = 'margin/group';

    /**
     *
     * @type {string}
     */
    static entity = 'marginGroups';

    static fields() {
		return {
			id: this.number(null).nullable(),
			margin_version_id: this.number(null).nullable(),
			start: this.attr(null),
			end: this.attr(null),
			type_cid: this.attr(null),
			adult: this.attr(null),
			child: this.attr(null),
			baby: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            days: this.hasMany(Day, 'margin_group_id'),
		}
	}

    Days() {
        return this.getRelated('days');
    }
}
